import { render, staticRenderFns } from "./UploadSingleEditor.vue?vue&type=template&id=273be41f&scoped=true&"
import script from "./UploadSingleEditor.vue?vue&type=script&lang=js&"
export * from "./UploadSingleEditor.vue?vue&type=script&lang=js&"
import style0 from "./UploadSingleEditor.vue?vue&type=style&index=0&id=273be41f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273be41f",
  null
  
)

export default component.exports